import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CRow,
  CForm,
  CFormInput,
} from '@coreui/react'
import { loginRequest } from '../../../config/authConfig';
import PropTypes from 'prop-types'

import { ReactComponent as OWTLogo } from '../../../assets/brand/OneWeb-Technologies-Logo.svg';
import OWTWhiteLogo from 'src/assets/brand/OneWeb_Technologies_Logo_Horizontal_White.png'

import 'react-toggle/style.css'

import { useMsal } from '@azure/msal-react'


const Splash = ({error, ackResponse, authState, ...props}) => {
  const { instance } = useMsal();
  const [loginHint, setLoginHint] = useState(false);
  const msalInstance = instance;

  const handleLoginRedirect = () => {
    msalInstance.loginRedirect(loginRequest)
      .catch((error) => console.log(error));
  };

  // useEffect(() => {
  //   // Delay for 5 seconds and pop up a login hint if we haven't redirected
  //   if (!awaitingAuth && !showAcknowledgement) {
  //     setLoginHint(false);
  //     setTimeout(() =>{
  //       console.log('setLoginHint');
  //       setLoginHint(true);
  //     }, 500);
  //   } else {
  //     setLoginHint(true);
  //   }
  // }, [awaitingAuth, showAcknowledgement]);


  const authResponse = (accepted) => {
    if (accepted) {
      sessionStorage.setItem('b2c_redirect','true');
      handleLoginRedirect();
    } else {
      window.location.href = 'https://eutelsatns.us'
    }
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const params = new URLSearchParams();
    params.append('username',event.target[0].value);
    let auth_type = await fetch('/api/v1/auth/authtype?'+params);
    if(auth_type.status === 201){
        let resp_body = await auth_type.json();
        let idp_id = resp_body.idp_id;
        window.location.href = `/api/v1/auth/saml-login/${idp_id}`;
    }
    if(auth_type.status === 200){
      handleLoginRedirect();
    }
  }
  return (
    <>
     <div id="background_branding_container" data-tenant-branding-background-color="true">
      <img data-tenant-branding-background="true" src="https://aadcdn.msftauthimages.us/6ebb54f4-zwzodockmikaayxrlkfrkp7yfzm794kqw7fnfdh-zto/logintenantbranding/0/illustration?ts=638672780084715187" />
    </div>
    <div className="min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCardGroup>
              <CCard className="p-4" style={{backgroundColor:'#003c78'}}>
                <CCardBody>
                  <OWTLogo height={65} className='d-block mx-auto hide-when-dark' />
                  <img src={OWTWhiteLogo} height={65} className='d-block mx-auto show-when-dark' />
                  <div id="api">
                    {(authState === 'SHOWACK') &&
                      <>
                      <div className="intro">
                        <h2>Consent to Monitoring</h2>
                      </div>
                      <div className="entry">
                        <p style={{textAlign: 'justify'}}>
                          By clicking OK, you acknowledge and consent to the following:<br/><br/>
                          This system may contain federal contract information and controlled unclassified information and is for use by authorized personnel only. Unauthorized use may be subject to criminal and civil penalties. All communications and data transiting, traveling to or from, or stored on this system will be monitored. You consent to the unrestricted monitoring, interception, recording, and searching of all communications and data transiting, traveling to or from, or stored on this system at any time and for any purpose by OneWeb Technologies and by any person or entity, including government entities, authorized by OneWeb Technologies. You also consent to the unrestricted disclosure of all communications and data transiting, traveling to or from, or stored on this system at any time and for any purpose to any person or entity, including government entities, authorized by OneWeb Technologies. You acknowledge that you have no reasonable expectation of privacy regarding your use of this system. These acknowledgments and consents cover all use of the system, including work-related use and personal use without exception.                            
                        </p>
                      </div>
                      <div className="buttons">
                        <CButton color="secondary" onClick={() => authResponse(false)}>Decline & Logout</CButton>
                        <CButton style={{marginLeft: 'auto',backgroundColor: '#007dba', width: '120px' }} onClick={() => authResponse(true)}>OK</CButton>
                      </div>
                      </>
                    }
                    {(authState === 'AUTHING') &&
                        <div className="intro">
                          <h2>Authenticating...</h2>
                        </div>
                    }
                    {(authState === 'LOADING') &&
                        <div className="intro">
                          <h2>Loading...</h2>
                        </div>
                    }
                    {error && 
                        <div className="intro">
                          <h2 style={{color: 'darkred'}}>{error}</h2>
                        </div>
                    }
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    
    </>
  )
}
Splash.propTypes = {
  error: PropTypes.any,
  ackResponse: PropTypes.any,
  authState: PropTypes.any,
}

export default Splash